<template>
  <v-dialog :scrollable="true" v-model="dialog" max-width="500px">
    <v-card>
      <v-card-title class="headline">{{isNew ? 'Crear structura' : 'Editar structura'}}</v-card-title>
      <v-card-text>
        <v-text-field
          label="Nombre de la structura"
          v-model="structureName"
          @blur="checkStructureName()"
          :loading="checkingStructureName"
          :error-messages="checkingStructureNameMessages"
        ></v-text-field>

        <v-text-field
          label="Nombre del Folder"
          :value="folderName"
          readonly
        ></v-text-field>

        <v-container>
          <v-layout row wrap>
            <structure-item xs12
              v-for="(i, $index) in structureItems"
              :key="$index"
              :structure-item-data="i"
            ></structure-item>
          </v-layout>
        </v-container>

      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-2" flat="flat" @click.native="dialog = false">Cerrar</v-btn>
        <v-btn :disabled="!canSaveStructure" color="blue darken-1" flat="flat" @click.native="sendNewData()">Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import eventBus from '../../utils/eventBus'
import StructureItem from '../structures/structure-item.vue'

import structureStorage from '../../storage/structureStorage.js'

export default {
  name: 'structure-form-dialog',
  created () {
    eventBus.$off('open-structure-form')
    eventBus.$on('open-structure-form', (data) => {
      this.isNew = data.structureID === undefined
      this.structureItems = data.structureItems.map(item => ({
        itemName: item.itemName,
        description: `${this.folderName}: ${item.itemName}`,
        labels: `${this.folderName}, ${item.itemName}`,
        imageUrl: item.imageUrl
      }))
      this.structureName = data.structureName
      this.dialog = true

      this.checkStructureName()
    })
  },
  data () {
    return {
      isNew: false,
      dialog: false,
      checkingStructureName: false,
      checkingStructureNameMessages: [],
      canSaveStructure: false,
      folderName: '$$FOLDER',
      structureName: '',
      structureItems: []
    }
  },
  methods: {
    checkStructureName () {
      // FIXME: Cuando se cierra el dialog el @blur del nombre de la estructura se sigue ejecutando :/
      if (this.checkingStructureName) {
        return
      }

      if (this.structureName.trim() === '') {
        this.checkingStructureNameMessages = ['El nombre de estructura no debe estar vacio']
        return
      }

      this.checkingStructureName = true
      this.canSaveStructure = false
      this.checkingStructureNameMessages = []

      structureStorage.checkStructureName({
        data: {
          structureName: this.structureName
        },
        onSuccess: (response) => {
          this.checkingStructureName = false
          // eslint-disable-next-line
          if (response.data.exists == 1) {
            this.checkingStructureNameMessages = ['El nombre de estructura ya existe']
            this.canSaveStructure = false
          }

          // eslint-disable-next-line
          if (response.data.exists == 0) {
            this.canSaveStructure = true
          }
        },
        onError: () => {
          this.checkingStructureNameMessages = ['Ha habido un problema con el servidor']
          this.checkingStructureName = false
        }
      })
    },
    sendNewData () {
      const data = {
        structureName: this.structureName,
        folderName: this.folderName,
        structureItems: this.structureItems
      }
      structureStorage.createStructure({
        data,
        onSuccess: () => {
          console.log('success yay!')
          this.dialog = false
        },
        onError: (error) => {
          if (error.response && error.response.data && error.response.data.code === 'ER_DUP_ENTRY') {
            console.log('don worry about it, it just a duplicate')
            eventBus.$emit('open-custom-snack-bar', {message: 'Nombre de la plantilla es duplicado'})
          }
          console.log('error fuck!')
        }
      })
    }
  },
  components: {
    StructureItem
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dialogs/structure-form-dialog.vue